import * as React from "react";

const SevenToEigthNoText = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_15875_4628"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        y="24"
        width="24"
        height="24"
        transform="rotate(-90 0 24)"
        fill="white"
        fillOpacity="0.92"
      />
    </mask>
    <g mask="url(#mask0_15875_4628)">
      <path
        d="M20 19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H6C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19L4 5C4 4.45 4.19583 3.97917 4.5875 3.5875C4.97917 3.19583 5.45 3 6 3H18C18.55 3 19.0208 3.19583 19.4125 3.5875C19.8042 3.97917 20 4.45 20 5V19ZM18 19V5H6L6 19H18Z"
        fill="#F0F0F0"
      />
    </g>
  </svg>
);

export default SevenToEigthNoText;
